import React from 'react'

const MoneyInput = () => (
  <div className="subcontainer_input_MoneyInput col-3 col-md-5 px-2 d-flex flex-column align-items-center justify-content-center">
    <p className="text-uppercase font-weight-bold mb-0">Total</p>
    <p className="mb-0">S/. 140.00</p>
  </div>
)

export default MoneyInput